import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { USER_LOCALSTORAGE_KEY } from "../../../../shared/const/localstorage";
import {fetchProfileData} from "../../../../entities/Profile/model/fetchProfileDate/fetchProfileDate";


type FileArgument = File;

export const uploadAvatar = createAsyncThunk(
    "user/uploadAvatar",
    async (file: FileArgument, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }

            const { token } = JSON.parse(authToken);

            const formData = new FormData();
            formData.append("image", file);

            const response = await axios.post("/api/profile/avatar", formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            if (response.status === 200) {
                await thunkAPI.dispatch(fetchProfileData());
            } else {
                throw new Error('Failed to delete avatar');
            }

            return response.data;
        } catch (e) {
            // Обработайте ошибку и верните ее как rejectWithValue
            // @ts-ignore
            return thunkAPI.rejectWithValue(e.message);
        }
    }
);